import { render, staticRenderFns } from "./projectform.vue?vue&type=template&id=f12f62d2&scoped=true"
import script from "./projectform.vue?vue&type=script&lang=js"
export * from "./projectform.vue?vue&type=script&lang=js"
import style0 from "./projectform.vue?vue&type=style&index=0&id=f12f62d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12f62d2",
  null
  
)

export default component.exports